import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

export default function DeleteCdd() {
  const [search, setSearch] = useState("");

  const [cddList, setCddList] = useState([]);
  const token = sessionStorage.getItem("token");




  /* =========================
     FETCH ALL CDD
  ========================= */
  const fetchCDD = async () => {
    try {
      const res = await axios.get("https://irc.zentelex.com/api/delete/cdd", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setCddList(res.data.data || []);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to fetch CDD data", "error");
    }
  };

  useEffect(() => {
    fetchCDD();
  }, []);

  /* =========================
     DELETE CDD
  ========================= */



 const handleDelete = async (data) => {

  /* ======================
     CREATE DATA TABLE
  ====================== */

  const rows = Object.entries(data)
    .map(([key, value]) => `
      <tr>
        <td style="width:35%;padding:6px"><b>${key}</b></td>
        <td style="padding:6px">${value ?? "-"}</td>
      </tr>
    `)
    .join("");

  /* ======================
      SHOW PREVIEW MODAL
  ====================== */

  const confirm = await Swal.fire({
    title: "⚠ CDD Delete Confirmation",
    width: "75%",
    allowOutsideClick: false,
    backdrop: true,

    html: `
      <div style="max-height:500px;overflow:auto;text-align:left">
        <table border="1" style="width:100%;border-collapse:collapse">
          ${rows}
        </table>

        <p style="color:red;font-weight:bold;margin-top:10px">
          This action cannot be undone!
        </p>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "🗑 Yes Delete",
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c757d",
  });

  if (!confirm.isConfirmed) return;

  /* ======================
         DELETE API
  ====================== */

  try {

    Swal.fire({
      title: "Deleting...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    await axios.delete(
      `https://irc.zentelex.com/api/delete/cdd/${data.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    Swal.fire({
      icon: "success",
      title: "Deleted Successfully",
      timer: 1500,
      showConfirmButton: false,
    });

    fetchCDD();

  } catch (error) {
    console.error(error);
    Swal.fire("Error", "Delete failed", "error");
  }
};



  const filteredCddList = cddList.filter((item) => {
    const text = search.toLowerCase();

    return (
      item.cddNo?.toLowerCase().includes(text) ||
      item.documentDate?.toLowerCase().includes(text) ||
      item.clientName?.toLowerCase().includes(text) ||
      item.commodityName?.toLowerCase().includes(text) ||
      item.warehouseName?.toLowerCase().includes(text)
    );
  });

  return (
    <div className="container mt-4">
      <div className="card shadow border-0">
        <div className="card-header bg-danger text-white">
          <h4 className="mb-0">Delete Commodity Delivery Document</h4>
        </div>
        <br />

        <div className="mb-3">
          <input
            type="text"
            className="form-control border-primary"
            placeholder="🔍 Search CDD / Client / Commodity / Warehouse..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <br />

        <div className="card-body table-responsive">
          <table className="table table-bordered table-hover align-middle">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>CDD No</th>
                <th>Date</th>
                <th>Client</th>
                <th>Commodity</th>
                <th>Warehouse</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {cddList.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Records Found
                  </td>
                </tr>
              ) : (
                cddList.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.cddNo}</td>
                    <td>{item.documentDate}</td>
                    <td>{item.clientName}</td>
                    <td>{item.commodityName}</td>
                    <td>{item.warehouseName}</td>

                    <td>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(item)}
                      >
                        🗑 Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
